/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

import actionNames from './actionNames';

function updateMainUser(options) {
  return _.assign({}, {
    type: actionNames.updateMainUser,
    payload: options,
  });
}

function setAvailableProfiles(options) {
  return _.assign({}, {
    type: actionNames.setAvailableProfiles,
    payload: options,
  });
}

function setLoadingPercentage(options) {
  return _.assign({}, {
    type: actionNames.setLoadingProgress,
    payload: options,
  });
}

function setSystemMessage(options) {
  return _.assign({}, {
    type: actionNames.setSystemMessage,
    payload: options,
  });
}

function setContentEntry(options) {
  return _.assign({}, {
    type: actionNames.setContentEntry,
    payload: options,
  });
}

function setPendingEdit(data, validation) {
  return _.assign({}, {
    type: actionNames.setPendingEdit,
    payload: {
      data,
      validation,
    },
  });
}

function clearPendingEdit() {
  return _.assign({}, {
    type: actionNames.clearPendingEdit,
    payload: {},
  });
}

export {
  updateMainUser,
  setAvailableProfiles,
  setLoadingPercentage,
  setSystemMessage,
  setContentEntry,
  setPendingEdit,
  clearPendingEdit,
};
